/* eslint-disable no-console */
import {Table, TableProps} from 'antd';
import React from 'react';

import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import {formatIndian} from '../../../utils/formatIndian';
import {
  upstreamKey,
  upstreamLabel
} from '../../Forms/Constants/IP/UpstreamKeyLabel';

const SupplyChainTableDisplay: React.FC<{dataSource: any}> = ({dataSource}) => {
  const {frequency, modeOfTransport} = useJSONStore.getState();
  const {weight, distance} = useCompanyStore.getState().preUnits;
  interface DataType {
    _id: string;
    name: string;
    age: number;
    address: string;
  }

  const columns: TableProps<DataType>['columns'] = [
    {
      title: upstreamLabel.FREQUENCY_TRANSPORT,
      dataIndex: upstreamKey.FREQUENCY_TRANSPORT,
      width: 150,
      render: (value) => {
        return (
          <>
            {
              frequency?.find((item) => {
                return item.value === value;
              })?.label
            }
          </>
        );
      }
    },
    {
      title: upstreamLabel.FREQUENCY_NUM,
      dataIndex: upstreamKey.FREQUENCY_NUM,
      width: 120,
      render: (value) => {
        return <>{formatIndian(value)}</>;
      }
    },
    {
      title: upstreamLabel.MODE,
      dataIndex: upstreamKey.MODE,
      render: (value) => {
        return (
          <>
            {
              modeOfTransport?.find((item) => {
                return item.value === value;
              })?.label
            }
          </>
        );
      }
    },
    {
      title: upstreamLabel.QUANTITY,
      dataIndex: upstreamKey.QUANTITY,
      render: (value) => {
        return `${formatIndian(value)} ${weight}`;
      }
    },
    {
      title: upstreamLabel.DISTANCE_TRAVELLED,
      dataIndex: upstreamKey.DISTANCE_TRAVELLED,
      render: (value) => {
        return `${formatIndian(value)} ${distance}`;
      }
    }
  ];

  return (
    <Table
      bordered={false}
      columns={columns}
      dataSource={dataSource}
      pagination={{pageSize: 50}}
      scroll={{y: 240}}
      rowKey="_id"
      // tableLayout="auto"
    />
  );
};

export default SupplyChainTableDisplay;
